export default __webpack_public_path__ + "static/media/logo.71841976.png";